/**
 * Prioridade / switch-off de tracks remotas para salas com muitos participantes.
 */

import { shouldUseTrackPriority } from "./videoRemoteLayout";

function isScreenShareTrack(track) {
  if (!track) return false;
  const name = String(track.name || "").trim().toLowerCase();
  return (
    track.kind === "video" &&
    (name.includes("screen") || name.includes("presentation") || track.isScreenShare === true)
  );
}

/**
 * @param {import('twilio-video').Room | null | undefined} room
 * @param {{
 *   remoteCount: number,
 *   focusSids?: Set<string>|string[],
 *   isScreenShareTrack?: (track: any) => boolean,
 * }} opts
 */
export function applyRemoteVideoPriorities(room, opts = {}) {
  if (!room?.participants) return;
  const remoteCount = Math.max(0, Number(opts.remoteCount) || 0);
  const usePriority = shouldUseTrackPriority(remoteCount);
  const focus = new Set(
    Array.isArray(opts.focusSids) ? opts.focusSids : opts.focusSids ? [...opts.focusSids] : []
  );
  const screenCheck =
    typeof opts.isScreenShareTrack === "function" ? opts.isScreenShareTrack : isScreenShareTrack;

  room.participants.forEach((participant) => {
    const sid = String(participant.sid || "");
    const isFocus = focus.has(sid);
    participant.videoTracks?.forEach?.((pub) => {
      const track = pub?.track;
      if (!track) return;
      const screen = screenCheck(track);
      let priority = "standard";
      if (screen || isFocus) priority = "high";
      else if (usePriority) priority = "low";

      try {
        if (typeof pub.setPriority === "function") pub.setPriority(priority);
        else if (typeof track.setPriority === "function") track.setPriority(priority);
      } catch {
        /* ignore unsupported */
      }

      // Com muitos remotes, desliga decodificação de vídeo fora do foco (áudio segue).
      if (!screen && usePriority && !isFocus) {
        try {
          if (typeof track.switchOff === "function") track.switchOff();
          else if (track.isEnabled !== false && typeof track.disable === "function") {
            /* remote tracks geralmente não suportam disable — ignore */
          }
        } catch {
          /* ignore */
        }
      } else if (!screen && typeof track.switchOn === "function") {
        try {
          track.switchOn();
        } catch {
          /* ignore */
        }
      }
    });
  });
}
